import {Injectable} from "@angular/core";
import {DeviceDefectModel, deviceDefectModelFactory, deviceDefectModelListFactory} from "./device-defect.model";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_LIMIT = 10;

@Injectable()
export class DeviceDefectService {
  private url: string = "/api/devicedefect";

  constructor(private http: HttpClient) {}

  async getDeviceDefectById(id): Promise<DeviceDefectModel> {
    if (!id) return deviceDefectModelFactory();

    return this.http.get(`${this.url}/${id}`)
      .pipe(map(deviceDefectModelFactory))
      .toPromise();
  }

  getDeviceDefects(
    page = DEFAULT_PAGE,
    limit = DEFAULT_PAGE_LIMIT,
    search: string,
    siteId: string,
    projectId: string,
  ): Promise<{rows: DeviceDefectModel[], count: number}> {
    const params = {
      ...page && {page: `${page}`},
      ...limit && {limit: `${limit}`},
      ...search && {search},
      ...siteId && {siteId},
      ...projectId && {projectId},
      sequence: "true",
    };

    return this.http.get<{rows: any[], count: any}>(`${this.url}`, {params})
      .pipe(map(json => ({rows: deviceDefectModelListFactory(json.rows), count: +json.count})))
      .toPromise();
  }

  saveDefect(name: string, siteId: string): Promise<boolean> {
    return this.http.post(`${this.url}/create`, {name, siteId})
      .toPromise()
      .then(() => true);
  }
}
